import { createApi } from '@reduxjs/toolkit/query/react';

import { DownloadReportRequestDto, StatusDto } from '../common/dto/common.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_REPORT_SERVICE;
const TAG_TYPE = 'DownloadReport';

export const downloadReportApi = createApi({
  reducerPath: 'downloadReportApi',
  baseQuery: customFetchBase(`${API_URI}/api/download-report`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    downloadNormalReport: builder.mutation<StatusDto, DownloadReportRequestDto>({
      query(body) {
        return {
          url: `normal`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    downloadExceptionReport: builder.mutation<StatusDto, DownloadReportRequestDto>({
      query(body) {
        return {
          url: `exception`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useDownloadNormalReportMutation, useDownloadExceptionReportMutation } = downloadReportApi;
